import { render, staticRenderFns } from "./billCenter.vue?vue&type=template&id=5433b416"
import script from "./billCenter.vue?vue&type=script&lang=js"
export * from "./billCenter.vue?vue&type=script&lang=js"
import style0 from "./billCenter.vue?vue&type=style&index=0&id=5433b416&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports